import { useAtom, useAtomValue } from "jotai";
import { inputClass, selectClass } from "@/lib/forms";
import { atoms } from "@/state";

export const GalleryFilterBar: React.FC = () => {
  const [filter, setFilter] = useAtom(atoms.photos.galleryFilter);
  const uploaders = useAtomValue(atoms.photos.galleryUploaders);
  const models = useAtomValue(atoms.data.models);
  const total = useAtomValue(atoms.photos.allPhotosFlat).length;
  const shown = useAtomValue(atoms.photos.galleryFiltered).length;

  const modelCodes = Object.keys(models).sort((a, b) => a.localeCompare(b));
  const hasActiveFilter =
    filter.codeSubstr !== "" || filter.uploader !== "" || filter.modelCode !== "";

  return (
    <div className="sticky top-0 z-10 -mx-6 mb-6 border-b border-gray-200 bg-white/95 px-6 py-3 backdrop-blur dark:border-gray-800 dark:bg-gray-950/95">
      <div className="flex flex-wrap items-center gap-3">
        <input
          value={filter.codeSubstr}
          onChange={(e) => setFilter({ ...filter, codeSubstr: e.target.value })}
          placeholder="Filter by code…"
          className={`${inputClass} w-56 font-mono`}
          aria-label="Filter by code"
        />
        <select
          value={filter.modelCode}
          onChange={(e) => setFilter({ ...filter, modelCode: e.target.value })}
          className={selectClass}
          aria-label="Filter by model"
        >
          <option value="">All models</option>
          {modelCodes.map((mc) => (
            <option key={mc} value={mc}>
              {mc}
            </option>
          ))}
        </select>
        <select
          value={filter.uploader}
          onChange={(e) => setFilter({ ...filter, uploader: e.target.value })}
          className={selectClass}
          aria-label="Filter by uploader"
        >
          <option value="">All uploaders</option>
          {uploaders.map((u) => (
            <option key={u} value={u}>
              {u}
            </option>
          ))}
        </select>
        {hasActiveFilter && (
          <button
            type="button"
            onClick={() => setFilter({ codeSubstr: "", uploader: "", modelCode: "" })}
            className="text-xs text-blue-600 underline hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-200"
          >
            Clear
          </button>
        )}
        <span className="ml-auto text-xs text-gray-500 dark:text-gray-400">
          {hasActiveFilter ? `${shown} of ${total}` : `${total}`} photo{total === 1 ? "" : "s"}
        </span>
      </div>
    </div>
  );
};
